import { assertNever } from '@client/new/helpers/types';

import { ProgramStateKind } from '../../model/programs.types';

import * as styles from './StatusTag.css';

export const toStateLabel = (state: ProgramStateKind): string => {
  switch (state) {
    case 'draft':
      return 'Draft';
    case 'ready':
      return 'Ready';
    case 'published':
      return 'Published';
    case 'archived':
      return 'Archived';
    default:
      return assertNever(state);
  }
};

type StatusTagProps = {
  state: ProgramStateKind;
};

export const StatusTag = ({ state }: StatusTagProps) => (
  <span className={styles.tag({ state })}>{toStateLabel(state)}</span>
);
